import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBriefcase as faBriefcaseDuotone,
  faHeart as faHeartDuotone,
  faShield as faShieldDuotone,
  faSmile as faSmileDuotone,
} from '@fortawesome/pro-duotone-svg-icons';
import { faBriefcase, faHeart, faShield, faSmile } from '@fortawesome/pro-regular-svg-icons';

import { IQDisplayMode } from '../../constants/IQDisplayMode';

interface IIconProps {
  regular: IconDefinition;
  duotone: IconDefinition;
}

const getIconProps = ({ regular, duotone }: IIconProps) => ({
  [IQDisplayMode.COMPACT]: { iconType: regular, size: 18, color: 'black' },
  [IQDisplayMode.COMFORTABLE]: { iconType: regular, size: 18, color: 'black' },
  [IQDisplayMode.STAND_ALONE]: { iconType: duotone, size: 18, color: 'aiPrimary' },
});

export const IQRefineItems = [
  {
    modeID: 'CASUAL',
    title: 'Casual',
    description: 'Relaxed, conversational, and friendly.',
    iconProps: getIconProps({ regular: faSmile, duotone: faSmileDuotone }),
  },
  {
    modeID: 'EMPATHETIC',
    title: 'Empathetic',
    description: 'Warmth, care, and emotional sensitivity.',
    iconProps: getIconProps({ regular: faHeart, duotone: faHeartDuotone }),
  },
  {
    modeID: 'PROFANITY',
    title: 'Profanity-Free',
    description: 'Flags inappropriate or offensive language.',
    iconProps: getIconProps({ regular: faShield, duotone: faShieldDuotone }),
  },
  {
    modeID: 'PROFESSIONALISM',
    title: 'Professional',
    description: 'Formal, respectful, and business-appropriate.',
    iconProps: getIconProps({ regular: faBriefcase, duotone: faBriefcaseDuotone }),
  },
];

export type TIQRefineItem = (typeof IQRefineItems)[number];
